import marked from 'marked';
import sanitize from './SanitizeHtml';
import { isEmpty } from './StringUtil';

marked.setOptions({
  breaks: true,
});

export default (markdown?: string) => {
  if (isEmpty(markdown)) {
    return '';
  }
  return marked(sanitize(String(markdown)));
};
